import React from 'react';
import { useTranslation } from 'react-i18next';
import Benefit from '../Benefit';
import BenefitPlaceholder from '../BenefitPlaceholder';
import s from './Benefits.scss';
const Benefits = ({ benefits, hasDiscord, showPlaceholder })=>{
    const { t } = useTranslation();
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, hasDiscord && /*#__PURE__*/ React.createElement(Benefit, {
        isDiscord: true,
        benefit: t('deviationview.tierCard.benefits.discord'),
        className: s['benefit']
    }), benefits.map((benefit, index)=>/*#__PURE__*/ React.createElement(Benefit, {
            key: index,
            benefit: benefit,
            className: s['benefit']
        })), showPlaceholder && benefits.length === 0 && /*#__PURE__*/ React.createElement(BenefitPlaceholder, null));
};
Benefits.displayName = 'Benefits';
export default Benefits;

//# sourceMappingURL=Benefits.js.map